// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import Default from './ui/versions/Default.vue'
import Rich from './ui/versions/Rich.vue'

/**
 * @author Filip Rurk <filip.rurak@movecloser.pl>
 */
export enum NewsletterModuleLayout {
  Default = 'default',
  Rich = 'rich'
}

/**
 * @author Filip Rurk <filip.rurak@movecloser.pl>
 */
export const NEWSLETTER_MODULE_KEY = 'NewsletterModule'

/**
 * @author Filip Rurk <filip.rurak@movecloser.pl>
 */
export interface NewsletterModuleConfig {
  alertButtonTheme: string
  buttonHasLabel: boolean
  buttonIcon: string
  buttonTheme: string
  layout: string
  isSubscriptionByUser: boolean
}

/**
 * @author Filip Rurk <filip.rurak@movecloser.pl>
 */
export const NEWSLETTER_MODULE_CONFIG_MAP: NewsletterModuleConfig = {
  alertButtonTheme: 'primary',
  buttonHasLabel: true,
  buttonIcon: '',
  buttonTheme: 'primary',
  layout: 'default',
  isSubscriptionByUser: true
}

/**
 * @author Filip Rurk <filip.rurak@movecloser.pl>
 */
export const newsletterModuleVersionsRegistry: Record<string, VueConstructor> = {
  [NewsletterModuleLayout.Default]: Default,
  [NewsletterModuleLayout.Rich]: Rich
}
